import { render } from "./LicenseComponent.vue?vue&type=template&id=55b00b8a"
import script from "./LicenseComponent.vue?vue&type=script&lang=js"
export * from "./LicenseComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/License/LicenseComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "55b00b8a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('55b00b8a', __exports__)) {
    api.reload('55b00b8a', __exports__)
  }
  
  module.hot.accept("./LicenseComponent.vue?vue&type=template&id=55b00b8a", () => {
    api.rerender('55b00b8a', render)
  })

}


export default __exports__